import type { ValidCombinationDto } from "@normax-performance/shared-types";
import type { NormedRowState } from "./daily-entry.types";

/** Shared Product+Operation -> norm snapshot resolution (DAILY_ENTRY_INTERACTION_SPEC.md §5/§6). */
export function resolveMatchedNorm(
  row: Pick<NormedRowState, "productId" | "operationId">,
  validCombinations: ValidCombinationDto[],
): ValidCombinationDto | null {
  return (
    validCombinations.find(
      (c) => c.operationId === row.operationId && (c.productId ?? null) === (row.productId ?? null),
    ) ?? null
  );
}
